export const HOMEPAGE_CLEAR_DATA = 'HOMEPAGE_CLEAR_DATA';
export const HOMEPAGE_SELECT_LANGUAGE = 'HOMEPAGE_SELECT_LANGUAGE';

export const HOMEPAGE_DATA_FETCH = 'HOMEPAGE_DATA_FETCH';
export const HOMEPAGE_DATA_SUCCESS = 'HOMEPAGE_DATA_SUCCESS';
export const HOMEPAGE_DATA_FAILURE = 'HOMEPAGE_DATA_FAILURE';

export const UPDATE_HOMEPAGE_DATA_FETCH = 'UPDATE_HOMEPAGE_DATA_FETCH';
export const UPDATE_HOMEPAGE_DATA_SUCCESS = 'UPDATE_HOMEPAGE_DATA_SUCCESS';
export const UPDATE_HOMEPAGE_DATA_FAILURE = 'UPDATE_HOMEPAGE_DATA_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/HomepageSettings/actionTypes.js